<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
    <b-form
      v-if="request"
      @keypress.enter.prevent
      @submit.prevent="handleSubmit(send())"
    >
      <!-- LOCALISATION DU SITE CONCERNE PAR LA DEMANDE -->
      <div class="block-flat">
        <div class="header">
          <h3>Localisation du site concerné par la demande</h3>
        </div>

        <div class="block-content">
          <fieldset>
            <legend>
              Utiliser l'assistant cartographique pour localiser le chantier
            </legend>

            <autocomplete
              placeholder="Rechercher une adresse..."
              :source="getApi()"
              input-class="form-control"
              @selected="selectedAddress($event)"
              results-property="features"
              :results-display="formattedDisplay"
            >
              <template v-slot:noResults> Pas de résultat </template>
            </autocomplete>
            <b-alert show variant="info" class="no-margin-bottom mt-3">
              Utilisez les boutons à gauche dans la carte pour schématiser
              l'emprise des travaux.<br />
              Vous pouvez affiner la position du chantier en déplacant le
              marqueur.
            </b-alert>
            <div id="container-map">
              <maps
                :draw="true"
                @pointMoved="pointMoved($event)"
                @featuresDrawed="finishdraw($event)"
                :defaultLayers="['TRANSPORTNETWORKS.ROADS']"
                :vectorLayers="vectorLayers"
                width="calc(100%)"
              ></maps>
            </div>
          </fieldset>

          <fieldset>
            <legend>Voie concernée</legend>
            <div class="form-group">
              <b-row>
                <b-col
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"><b>Type de voie :</b></label>
                </b-col>
                <b-col
                  xl="10"
                  lg="9"
                  md="9"
                  sm="12"
                  cols="12"
                  class="form-with-label"
                >
                  <b-form-radio-group
                    v-model="request.wayType"
                    :options="wayTypes"
                    value-field="value"
                    text-field="text"
                  ></b-form-radio-group>
                </b-col>
                <!-- TODO : way_type (autoroute, nationale, departementale, communale, + way_num (numéro) -->
                <b-col
                  v-if="request.wayType == 'Autoroute'"
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label font-normal"
                    >Autoroute n° :</label
                  >
                </b-col>
                <b-col
                  v-if="request.wayType == 'Autoroute'"
                  xl="10"
                  lg="9"
                  md="9"
                  sm="12"
                  cols="12"
                >
                  <b-input
                    v-model="request.wayNum"
                    placeholder="Autoroute n°"
                  ></b-input>
                </b-col>
                <b-col
                  v-if="request.wayType == 'Route nationale'"
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label font-normal"
                    >Route nationale n° :</label
                  >
                </b-col>
                <b-col
                  v-if="request.wayType == 'Route nationale'"
                  xl="10"
                  lg="9"
                  md="9"
                  sm="12"
                  cols="12"
                >
                  <b-input
                    v-model="request.wayNum"
                    placeholder="Route nationale n°"
                  ></b-input>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12"></b-col>
                <b-col
                  v-if="request.wayType == 'Route départementale'"
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label font-normal"
                    >Route départementale n° :</label
                  >
                </b-col>
                <b-col
                  v-if="request.wayType == 'Route départementale'"
                  xl="10"
                  lg="9"
                  md="9"
                  sm="12"
                  cols="12"
                >
                  <b-input
                    v-model="request.wayNum"
                    placeholder="Route départementale n°"
                  ></b-input>
                </b-col>
                <b-col
                  v-if="
                    request.wayType == 'Voie communale / Voie intercommunale'
                  "
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label font-normal"
                    >Voie communale / Voie intercommunale n° :</label
                  >
                </b-col>
                <b-col
                  v-if="
                    request.wayType == 'Voie communale / Voie intercommunale'
                  "
                  xl="10"
                  lg="9"
                  md="9"
                  sm="12"
                  cols="12"
                >
                  <b-input
                    v-model="request.wayNum"
                    placeholder="Voie communale / Voie intercommunale n°"
                  ></b-input>
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding clearfix"></b-col>-->
                <b-col
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label clearfix"></label>
                </b-col>
                <b-col xl="10" lg="9" md="9" sm="12" cols="12">
                  <b-form-checkbox
                    class="inline-block mr-5"
                    v-model="request.extra_urban"
                  >
                    Hors agglomération
                  </b-form-checkbox>
                  <b-form-checkbox
                    class="inline-block"
                    v-model="request.intra_urban"
                  >
                    En agglomération
                  </b-form-checkbox>
                </b-col>
                <!-- POINT DE REPERE ROUTIER -->
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding marginTop"
                ></b-col>
                <b-col
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="hidden-md hidden-sm hidden-xs no-padding"
                >
                  <label class="control-label nopadding"></label>
                </b-col>
                <b-col xl="5" lg="4" md="12" sm="12" cols="12">
                  <!-- TODO à voir ce qu'on en fait -->
                  <b-form-checkbox
                    v-model="milestoneStart"
                    :disabled="true"
                    label=""
                  >
                    Point de Repère (PR) routier de début d’application :
                  </b-form-checkbox>
                </b-col>
                <b-col xl="2" lg="2" md="5" sm="12" cols="12">
                  <b-input
                    v-model="request.milestoneStart1"
                    placeholder=""
                  ></b-input>
                </b-col>
                <b-col
                  xl="1"
                  lg="1"
                  md="2"
                  sm="12"
                  cols="12"
                  class="text-center control-label font-normal"
                >
                  +
                </b-col>
                <b-col xl="2" lg="2" md="5" sm="12" cols="12">
                  <!-- TODO à voir -->
                  <b-input
                    v-model="request.milestoneStart2"
                    placeholder=""
                  ></b-input>
                </b-col>
                <!-- POINT DE REPERE ROUTIER FIN -->
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding marginTop"
                ></b-col>
                <b-col
                  xl="2"
                  lg="3"
                  class="hidden-md hidden-sm hidden-xs no-padding"
                >
                  <label class="control-label"></label>
                </b-col>
                <b-col xl="5" lg="4" md="12" sm="12" cols="12">
                  <!-- TODO à voir ce qu'on en fait -->
                  <b-form-checkbox
                    v-model="milestoneEnd"
                    :disabled="true"
                    label=""
                  >
                    Point de Repère (PR) routier de fin d’application :
                  </b-form-checkbox>
                </b-col>
                <b-col xl="2" lg="2" md="5" sm="12" cols="12">
                  <b-input
                    v-model="request.milestoneEnd1"
                    placeholder=""
                  ></b-input>
                </b-col>
                <b-col
                  xl="1"
                  lg="1"
                  md="2"
                  sm="12"
                  cols="12"
                  class="text-center control-label font-normal"
                >
                  +
                </b-col>
                <b-col xl="2" lg="2" md="5" sm="12" cols="12">
                  <!-- TODO à voir -->
                  <b-input
                    v-model="request.milestoneEnd2"
                    placeholder=""
                  ></b-input>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <b>Nota :</b> Pour connaître la délimitation du domaine public
                  routier au droit d’une propriété riveraine, il faut déposer,
                  auprès du gestionnaire de la route concernée et selon les
                  modalités qu’il aura fixées, en complément, une demande
                  d’alignement individuel.
                </b-col>
              </b-row>
            </div>
          </fieldset>
          <fieldset>
            <legend>Adresse</legend>
            <!-- TODO A REVOIR -->
            <div class="form-group">
              <b-row>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Numéro :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressNum"
                    placeholder="Numéro"
                  ></b-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Extension :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressExt"
                    placeholder="Extension"
                  ></b-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Type de voie :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressType"
                    placeholder="Type de voie"
                  ></b-input>
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Nom de voie :</label>
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12">
                  <b-input
                    v-model="request.addressName"
                    placeholder="Nom de la voie"
                  ></b-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Lieu-dit ou BP :</label>
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12">
                  <b-input
                    v-model="request.place"
                    placeholder="Lieu-dit ou boite postale"
                  ></b-input>
                </b-col>
                <!--<b-col lg="12" md="12" sm="12" cols="12" class="no-padding"></b-col>-->
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Localité :</label>
                </b-col>
                <b-col lg="6" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressCity"
                    placeholder="Localité"
                  ></b-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Code postal :</label>
                </b-col>
                <b-col lg="2" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.addressPostalCode"
                    placeholder="Code Postal"
                  ></b-input>
                </b-col>
              </b-row>
            </div>
            <div class="form-group">
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <label class="marginTop"><b>Référence cadastrale :</b></label>
                </b-col>

                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label clearfix">Section(s) :</label>
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12">
                  <b-input
                    v-model="request.sections"
                    placeholder="Section(s)"
                  ></b-input>
                </b-col>
                <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Parcelle(s) :</label>
                </b-col>
                <b-col lg="4" md="3" sm="12" cols="12">
                  <b-input
                    v-model="request.plotNumbers"
                    placeholder="Parcelle(s)"
                  ></b-input>
                </b-col>
              </b-row>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="stepper-control">
        <!-- <b-button
          variant="white"
          @click="previous"
          class="btn marginRight-10 marginBottom-15"
        >
          <font-awesome-icon
            icon="caret-left"
            class="marginRight-5"
          ></font-awesome-icon>
          Précédent
        </b-button> -->
        <b-button type="submit" variant="primary" class="marginBottom-15">
          <span>Suivant</span>
          <font-awesome-icon
            icon="caret-right"
            class="marginLeft-5"
          ></font-awesome-icon>
        </b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import _ from "underscore";
import maps from "../../components/Maps.vue";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import Point from "ol/geom/Point";
import Feature from "ol/Feature";
import MultiPolygon from "ol/geom/MultiPolygon";
import MultiLineString from "ol/geom/MultiLineString";
import MultiPoint from "ol/geom/MultiPoint";
export default {
  async mounted() {
    if (this.add == false) {
      this.addressSelected = this.point;
      window.Event.$emit("locatePoint", this.addressSelected);
      this.features[0].geometry.geometries.forEach(function (element) {
        let geom;

        switch (element.type) {
          case "MultiPolygon":
            geom = new MultiPolygon(element.coordinates);
            break;
          case "MultiLineString":
            geom = new MultiLineString(element.coordinates);
            break;
          case "MultiPoint":
            geom = new MultiPoint(element.coordinates);
            break;
        }
        let feature = new Feature({ geometry: geom });

        window.Event.$emit("AddDrawnFeature", feature);
      });
    }
    if (this.add == true) {
      this.request.lon = this.point.geometry.coordinates[0];
      this.request.lat = this.point.geometry.coordinates[1];
      this.addressSelected = [this.point];
      window.Event.$emit("locatePoint", this.addressSelected);
    }
  },
  props: ["add"],

  data: () => ({
    wayTypes: [
      { value: "Autoroute", text: "Autoroute" },
      { value: "Route nationale", text: "Route nationale" },
      { value: "Route départementale", text: "Route départementale" },
      {
        value: "Voie communale / Voie intercommunale",
        text: "Voie communale / Voie intercommunale",
      },
    ],
    addresses: [],
    addressSelected: [],
    addressSearch: "",
    type_voie: [
      "allée",
      "allee",
      "avenue",
      "boulevard",
      "carrefour",
      "chemin",
      "chaussée",
      "chaussee",
      "cité",
      "cite",
      "corniche",
      "cours",
      "domaine",
      "descente",
      "ecart",
      "esplanade",
      "faubourg",
      "grande",
      "grande-rue",
      "hameau",
      "halle",
      "halles",
      "impasse",
      "lieu-dit",
      "lieu",
      "lotissement",
      "marché",
      "marche",
      "montée",
      "montee",
      "passage",
      "place",
      "plaine",
      "plateau",
      "promenade",
      "parvis",
      "quartier",
      "quai",
      "residence",
      "résidence",
      "rue",
      "ruelle",
      "rocade",
      "rond",
      "rond-point",
      "route",
      "sente",
      "sentier",
      "sente-sentier",
      "sentier-sente",
      "square",
      "terre",
      "terre-plein",
      "traverse",
      "villa",
      "village",
    ],
  }),
  methods: {
    previous() {
      this.$emit("previous");
    },
    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (success == true) {
          this.$emit("submit");
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },

    ...Vuex.mapActions("Perimeter", ["getPerimeters"]),
    ...Vuex.mapActions("Dossiers", ["setDossier"]),

    async getPlotsSections(dep, geom) {
      return new Promise((resolve, reject) => {
        var myHeaders = new Headers({
          Authorization: "Bearer " + window.$cookies.get("token-sudthd"),
        });
        fetch(window.urlapi + "plots", {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ dep: dep, geom: geom }),
        })
          .then((res) => res.json())
          .then((res) => {
            this.request.plotNumbers = res.data.plots;
            this.request.sections = res.data.sections;
          });
      });
    },

    async pointMoved(coordinates) {
      this.request.lon = coordinates[0];
      this.request.lat = coordinates[1];
      // version deplacement
      this.request.operationCode = await this.getCodeOperateur(
        this.request.lon,
        this.request.lat
      );
      window.Event.$emit("locatePoint", this.request);

      // version geocodage
      fetch(
        window.ADDRESSREVERSEAPI +
          "?lon=" +
          coordinates[0] +
          "&lat=" +
          coordinates[1]
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.features[0]) {
            let addressSelected = res.features[0];
            // this.addressSelected = Object.freeze([addressSelected]);
            this.request.addressNum = addressSelected.properties.housenumber;
            this.request.addressExt = this.getExtension(
              addressSelected.properties.housenumber
            );
            this.request.addressType =
              this.getTypeVoie(addressSelected)["type"];
            this.request.addressName =
              this.getTypeVoie(addressSelected)["voie"];
            this.request.addressCity = addressSelected.properties.city;
            this.request.addressPostalCode =
              addressSelected.properties.postcode;
            // this.request.lon = addressSelected.geometry.coordinates[0];
            // this.request.lat = addressSelected.geometry.coordinates[1];
            // window.Event.$emit("locatePoint", this.request);
          }
        });
      //   this.request.operationCode = await this.getCodeOperateur(
      //     this.request.lon,
      //     this.request.lat
      //   );
    },
    async getOperator() {
      //operatorPerimeterId
      let search = {
        lon: this.request.lon,
        lat: this.request.lat,
        type: "operator",
      };
      this.operators = await this.getPerimeters(search);
      if (this.operators.length == 0) {
        this.request.showComboOperator = true;
        this.request.operatorPerimeterId = null;
        this.request.operator = null;
        this.request.queryOperator = "perimeter?limit=10&type=operator&q=";
      } else if (this.operators.length >= 1) {
        this.request.showComboOperator = true;
        this.request.operatorPerimeterId = null;
        this.request.operator = null;
        this.request.queryOperator =
          "perimeter?limit=10&type=operator&lon=" +
          this.request.lon +
          "&lat=" +
          this.request.lat +
          "&q=";
      }
      // } else {
      //   if (this.operators[0]) {
      //     this.request.operatorPerimeterId = this.operators[0].id;
      //     this.request.operator = this.operators[0];
      //     this.request.showComboOperator = true;
      //   }
      // }
    },
    async getCodeOperateur(lon, lat) {
      let rep = null;
      if (
        this.userConnected &&
        !this.userConnected.roles.includes("ROLE_USER")
      ) {
        rep = await this.getOperator();
      }
      return new Promise((resolve, reject) => {
        var myHeaders = new Headers({
          Authorization: "Bearer " + window.$cookies.get("token-sudthd"),
        });

        fetch(window.urlapi + "zone", {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ lon: lon, lat: lat }),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.data != null) {
              resolve(res.data.code_ope);
            } else {
              resolve(null);
            }
          });
      });
    },
    formattedDisplay(result) {
      return (
        result.properties.name +
        ", <b>" +
        result.properties.postcode +
        " " +
        result.properties.city +
        "</b>"
      );
    },
    getApi() {
      return window.ADDRESSAPI;
    },
    retourValue(array, depart) {
      let retour = "";
      for (let i = depart; i < array.length; i++) {
        if (retour != "") retour += " ";
        retour += array[i];
      }
      return retour;
    },
    getTypeVoie(data) {
      let chaine;
      if (data.properties.street !== undefined) {
        chaine = data.properties.street;
      } else {
        chaine = data.properties.name;
      }

      var find = false;
      var retour = [];

      var arrSplit = chaine.split(" ");
      if (arrSplit.length > 1) {
        if (this.type_voie.indexOf(arrSplit[0].toLowerCase()) >= 0) {
          var temp0 = arrSplit[0].toLowerCase();
          var temp1 = arrSplit[1].toLowerCase();
          switch (temp0) {
            case "grande":
              if (temp1 == "rue") {
                retour["type"] = "Grande-Rue";
                if (arrSplit.length == 2) retour["voie"] = "Grande-Rue";
                else retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            case "lieu":
              if (temp1 == "dit") {
                retour["type"] = "Lieu-dit";
                retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            case "rond":
              if (temp1 == "point") {
                retour["type"] = "Rond-Point";
                retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            case "sente":
              if (temp1 == "sentier") {
                retour["lieu-dit"] = "Sente-Sentier";
                retour["voie"] = this.retourValue(arrSplit, 2);
              } else {
                retour["type"] = "Sente";
                retour["voie"] = this.retourValue(arrSplit, 1);
              }
              find = true;
              break;
            case "sentier":
              if (temp1 == "sente") {
                retour["lieu-dit"] = "Sente-Sentier";
                retour["voie"] = this.retourValue(arrSplit, 2);
              } else {
                retour["type"] = "Sentier";
                retour["voie"] = this.retourValue(arrSplit, 1);
              }
              find = true;
              break;
            case "terre":
              if (temp1 == "plein") {
                retour["type"] = "Terre-plein";
                retour["voie"] = this.retourValue(arrSplit, 2);
                find = true;
              }
              break;
            default:
              retour["type"] = arrSplit[0];
              retour["voie"] = this.retourValue(arrSplit, 1);
              find = true;
              break;
          }
        }
      }
      if (!find) {
        retour["type"] = "Lieu-dit";
        retour["voie"] = chaine;
      }

      return retour;
    },
    getExtension(housenumber) {
      let retour;
      if (housenumber !== undefined) {
        if (housenumber.indexOf(" ") !== -1) {
          arrSplit = housenumber.split(" ");
          retour = arrSplit[1];
        } else {
          retour = "";
        }
      } else {
        retour = "";
      }
      return retour;
    },
    async selectedAddress(result) {
      let addressSelected = result.selectedObject;
      this.addressSelected = Object.freeze([addressSelected]);

      this.request.addressNum = addressSelected.properties.housenumber;
      this.request.addressExt = this.getExtension(
        addressSelected.properties.housenumber
      );
      this.request.addressType = this.getTypeVoie(addressSelected)["type"];
      this.request.addressName = this.getTypeVoie(addressSelected)["voie"];
      this.request.addressCity = addressSelected.properties.city;
      this.request.addressPostalCode = addressSelected.properties.postcode;
      this.request.lon = addressSelected.geometry.coordinates[0];
      this.request.lat = addressSelected.geometry.coordinates[1];
      this.request.operationCode = await this.getCodeOperateur(
        this.request.lon,
        this.request.lat
      );

      window.Event.$emit("locatePoint", this.request);
    },
    //TODO: amelioré la construction du json
    finishdraw(features) {
      let tab = [];
      features.forEach((feature) => {
        tab.push(feature.geometry);
      });
      let obj = {
        type: "GeometryCollection",
        geometries: tab,
      };
      this.request.theGeom = obj;
      if (
        this.request.addressPostalCode != null &&
        this.request.addressPostalCode != ""
      ) {
        this.getPlotsSections(
          this.request.addressPostalCode.substr(0, 2),
          this.request.theGeom
        );
      }
    },
  },
  name: "Localisation",
  components: {
    maps: maps,
  },

  computed: {
    request: {
      get: function () {
        return this.dossierSelected;
      },
      set: function (newValue) {
        this.setDossier(newValue);
      },
    },
    ...Vuex.mapGetters("Dossiers", ["dossierSelected", "features", "point"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    vectorLayers() {
      let tab = [];

      tab.push({
        vectorZIndex: 200,
        ref: "dossierSelectedPointLayer",
        visible: true,
        movePoint: true,
        features: this.addressSelected,
        factory: function () {
          return (feature) => {
            return [
              new Style({
                zIndex: 150,
                image: new Icon({
                  src: require("../../img/google-marker.png"),
                  scale: 0.05,
                }),
              }),
            ];
          };
        },
        click: function (feature) {},
      });

      return tab;
    },
    milestoneEnd: {
      get() {
        return (
          (this.request.milestoneEnd1 &&
            this.request.milestoneEnd1 != "" &&
            this.request.milestoneEnd1 != null) ||
          (this.request.milestoneEnd2 &&
            this.request.milestoneEnd2 != "" &&
            this.request.milestoneEnd2 != null)
        );
      },
      set(value) {},
    },
    milestoneStart: {
      get() {
        return (
          (this.request.milestoneStart1 &&
            this.request.milestoneStart1 != "" &&
            this.request.milestoneStart1 != null) ||
          (this.request.milestoneStart2 &&
            this.request.milestoneStart2 != "" &&
            this.request.milestoneStart2 != null)
        );
      },
      set(value) {},
    },
  },
};
</script>

<style scoped></style>
